<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
  <div class="bgWhiteColor w-full max-w-lg rounded-lg p-6 shadow-xl">
    <div class="mb-1 flex items-center justify-between">
      <h2 class="textTableHeaderColor text-xl font-semibold" i18n="@@collectCashTitle">Collect Cash</h2>
      <app-close-button (closed)="onClosePopup()" />
    </div>

    <p class="text-gray mb-5 text-sm" i18n="@@collectCashConfirmText">
      Are you sure you want to confirm collect this order?
    </p>

    <!-- @if (showMismatchWarning()) {
      <div class="mb-5 rounded-lg border border-yellow-400 bg-yellow-50 p-4">
        <div class="mb-2 flex items-center gap-2">
          <svg class="h-5 w-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd" />
          </svg>
          <h3 class="text-sm font-bold text-yellow-800" i18n="@@warningTitle">Warning!</h3>
        </div>
        <p class="text-sm text-yellow-700">
          @if (discrepancyState() === "negative") {
            <span i18n="@@warningNegativeMessage">
              The amount entered is less than the expected amount. Difference:
              {{ expectedAmount() - (actualAmount() || 0) | number: "1.2-2" }} EGP. Do you want to proceed?
            </span>
          } @else {
            <span i18n="@@warningPositiveMessage">
              The amount entered is more than the expected amount. Difference:
              {{ (actualAmount() || 0) - expectedAmount() | number: "1.2-2" }} EGP. Do you want to proceed?
            </span>
          }
        </p>
      </div>
    } -->

    <form>
      <div class="mb-4 grid grid-cols-2 gap-4">
        <div>
          <label class="labelColorText mb-2 block text-sm font-medium" i18n="@@expectedAmountLabel">
            Expected Amount
          </label>
          <div class="bgBgColor borderDivColor flex items-center rounded-md border px-3 py-2">
            <span class="textTableBodyColor flex-1 text-sm">{{ expectedAmount() | number: "1.2-2" }}</span>
            <span class="textHelpercolorone text-xs" i18n="@@egp">EGP</span>
          </div>
        </div>

        <div>
          <label for="actualAmount" class="labelColorText mb-2 block text-sm font-medium" i18n="@@actualAmountLabel">
            Actual Amount Collected
          </label>
          <div
            class="borderhelpercolortwo focus-within:borderPrimaryColor flex items-center rounded-md border px-3 py-2"
            [class.bordererrorcolor]="amountTouched() && amountError()">
            <input
              [(ngModel)]="actualAmount"
              (blur)="onAmountBlur()"
              name="actualAmount"
              id="actualAmount"
              type="number"
              step="0.01"
              min="0"
              class="w-full flex-1 text-sm outline-none"
              placeholder="0.00" />
            <span class="textHelpercolorone text-xs" i18n="@@egp">EGP</span>
          </div>
          @if (amountTouched() && amountError()) {
            <p class="errortextcolor mt-1 text-xs">{{ amountError() }}</p>
          }
        </div>
      </div>

      @if (discrepancyState()) {
        <div class="mb-4 grid grid-cols-2 gap-4">
          <div>
            <label class="labelColorText mb-2 block text-sm font-medium" i18n="@@discrepancyLabel">Discrepancy</label>
            <div
              class="flex items-center rounded-md border px-3 py-2 text-sm font-medium"
              [class.bg-status-neutral]="discrepancyState() === 'zero'"
              [class.bg-status-danger]="discrepancyState() === 'negative'"
              [class.bg-status-success]="discrepancyState() === 'positive'">
              {{ discrepancyLabel() }}
            </div>
          </div>
        </div>
      }

      <div class="mb-6">
        <label for="comment" class="labelColorText mb-2 block text-sm font-medium" i18n="@@commentLabel">Comment</label>
        <textarea
          [(ngModel)]="comment"
          name="comment"
          id="comment"
          rows="4"
          maxlength="4000"
          placeholder="Add a comment (optional)"
          i18n-placeholder="@@commentPlaceholder"
          class="borderhelpercolortwo focus:borderPrimaryColor w-full rounded-md border px-3 py-2 text-sm outline-none"></textarea>
        <div class="mt-1 flex items-center justify-between">
          @if (commentError()) {
            <p class="errortextcolor text-xs">{{ commentError() }}</p>
          } @else {
            <span></span>
          }
          <span class="textHelpercolorone text-xs">{{ comment().length }}/{{ maxCommentLength }}</span>
        </div>
      </div>

      @if (err()) {
        <div class="mb-4">
          <app-error [apiError]="err()!" />
        </div>
      }

      <div class="flex justify-end gap-3">
        <button type="button" class="secondary-btn" (click)="onClosePopup()" i18n="@@cancel">Cancel</button>

        <button
          [disabled]="!canConfirm()"
          [class.opacity-50]="!canConfirm()"
          [class.pointer-events-none]="!canConfirm()"
          (click)="onSubmit($event)"
          type="submit"
          class="btn-primary">
          @if (loading()) {
            <span i18n="@@loading">loading...</span>
          } @else {
            <span i18n="@@confirmCollection">Confirm Collection</span>
          }
        </button>
      </div>
    </form>
  </div>
</div>
